import React, { useEffect } from 'react';
import { Route, Switch, useHistory } from 'react-router-dom';
import Lobby from './views/lobby/Lobby';
import NavBar from './components/Navbar/NavBar';
import TwoVsTwoTable from './components/tables/TwoVsTwo/TwoVsTwoTable';
import OneVsOneTable from './components/tables/OneVsOne/OneVsOneTable';
import './App.css';

import { useDispatch, useSelector } from 'react-redux';
import { setSocket, connectSocket } from './redux/actions/socketActions';

// Socket logic

import 'bootstrap/dist/css/bootstrap.min.css';
// import "./assits/css/main-dashboards.min.css";
function App() {
	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(connectSocket());
	}, []);
	const history = useHistory();
	const redirect = useSelector((state) => state.redirect);
	useEffect(() => {
		history.push(redirect.redirect);
	}, [redirect]);

	return (
		<Switch>
			<Route exact path="/" component={Lobby} />

			{/* <Route exact path="/nav" component={NavBar} /> */}
			<Route exact path="/2v2" component={TwoVsTwoTable} />
			<Route exact path="/1v1" component={OneVsOneTable} />
			{/* <Route exact path="/table" component={Table} /> */}
		</Switch>
	);
}

export default App;
